import { render, staticRenderFns } from "./ReviewRequestAcuteRecordDetails.vue?vue&type=template&id=e24f9bbe&scoped=true&"
import script from "./ReviewRequestAcuteRecordDetails.vue?vue&type=script&lang=js&"
export * from "./ReviewRequestAcuteRecordDetails.vue?vue&type=script&lang=js&"
import style0 from "./ReviewRequestAcuteRecordDetails.vue?vue&type=style&index=0&id=e24f9bbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e24f9bbe",
  null
  
)

export default component.exports